import { useQuery } from '@tanstack/react-query'
import type { FeatureFlagManageResponse } from '@app/types'
import { FeatureFlagService } from '../service/Admin.featureFlagService'

export const useFetchFeatureFlagRoles = () => {
  return useQuery<FeatureFlagManageResponse>({
    queryKey: ['admin-feature-flag-roles'],
    queryFn: FeatureFlagService.getFeatureFlagRoles,
  })
}
